import React from 'react'
import { observer } from 'mobx-react-lite'

import {
	WrapUpSectionLabel,
	WrapUpSectionContainer,
	Item,
} from './WrapUpSectionComponents'
import { graphql } from 'gatsby'

const Resources = ({ resources }) => {
	if (!resources) return null
	return (
		<WrapUpSectionContainer>
			<WrapUpSectionLabel>Resources</WrapUpSectionLabel>

			{resources.map((r, i) => (
				<Item {...r} />
			))}
		</WrapUpSectionContainer>
	)
}

export default observer(Resources)

export const query = graphql`
	fragment Resources on ContentfulArticle {
		resources {
			headlineContent {
				raw
			}
			copyContent {
				raw
			}
		}
	}
`
